import { Platform } from "react-native";

import { setExpoSecureStoreItemAsync } from "@whoosh/utilities/src/ExpoSecureStore/expoSecureStore";

export const setFiltersFromStorage = async (
  key: string,
  value: string
): Promise<boolean> => {
  if (key.length) {
    const safeKey = key.replace(/[^a-zA-Z0-9]/g, "");
    try {
      if (Platform.OS !== "web") {
        await setExpoSecureStoreItemAsync(safeKey, value);
      } else {
        localStorage.setItem(safeKey, value);
      }
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
  return true;
};
